<template>
  <div>
    <BaseTable
      class="table-shadow"
      :headers="headers"
      :items="info"
      :loading="loading"
      :paginate="true"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="id_colaborador"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Realizados</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <RegisterBottom v-can-access="792" @click="openModal('Cadastrar')" />
          <FilterIndividual
            @selectedFilters="fetchRealizadoIndividual((filters = $event))"
          />
        </v-toolbar>
      </template>

      <template v-slot:[`item.id_band`]="{ item }">
        <BaseSegmento :segmento="item.id_band" />
      </template>

      <template v-slot:[`item.nome`]="{ item }">
        {{ item.id_colaborador }} - {{ item.nome | TitleCase }}
      </template>

      <template v-slot:[`item.qtd_indicadores`]="{ item }">
        {{ item.dados.length }}
      </template>

      <template v-slot:[`item.departamento`]="{ item }">
        {{ item.departamento | TitleCase }}
      </template>

      <template v-slot:[`item.mes_ref`]="{ item }">
        {{ `${item.mes_ref}/${item.ano_ref}` }}
      </template>

      <!-- expanded -->

      <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded }">
        <v-btn small text v-if="!isExpanded" @click="expand(!isExpanded)">
          expandir
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <v-btn text small v-else @click="expand(!isExpanded)">
          ocultar
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td class="pa-0" :colspan="headers.length">
          <ListaRealizadoIndividual :items="item.dados" />
        </td>
      </template>
    </BaseTable>
    <ModalCadastro
      :dialog="dialog"
      :labelBtn="labelBtn"
      @closeModal="dialog = false"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/shared/NewBaseTable.vue";
import BaseSegmento from "@/components/shared/BaseSegmento.vue";
import RegisterBottom from "@/components/shared/bottons/RegisterBottom";
import FilterIndividual from "./FilterIndividual.vue";
import ModalCadastro from "./ModalIndividual.vue";
import comissao from "@/services/http/comissaoService";
import ListaRealizadoIndividual from "./ListaRealizadoIndividual.vue";

export default {
  components: {
    BaseTable,
    RegisterBottom,
    BaseSegmento,
    FilterIndividual,
    ModalCadastro,
    ListaRealizadoIndividual
  },

  data() {
    return {
      loading: false,
      dialog: false,
      singleExpand: false,
      labelBtn: "",
      expanded: [],
      filters: "",
      headers: [
        {
          text: "Segmento",
          value: "id_band"
        },
        {
          text: "Apelido",
          value: "apelido"
        },
        { text: "Colaborador", value: "nome" },
        { text: "Departamento", value: "departamento" },
        { text: "QTD Indicadores", value: "qtd_indicadores", align: "center" },
        { text: "Mes Ref", value: "mes_ref" }
      ],
      info: []
    };
  },

  methods: {
    openModal(label) {
      this.dialog = true;
      this.labelBtn = label;
    },
    async fetchRealizadoIndividual(filters) {
      this.loading = true;
      let { data } = await comissao()
        .realizadoIndividual()
        .show({
          per_page: -1,
          ativo: "S",
          id_tipo_evento: "C",
          id_tipo_dado: "R",
          ...filters
        });
      this.loading = false;
      const obj = this.groupByCompany(data.data, "id_colaborador");
      this.info = Object.values(obj);
    },

    groupByCompany(array, key) {
      return array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || {
          id_band: currentValue.id_band,
          apelido: currentValue.apelido,
          id_colaborador: currentValue.id_colaborador,
          nome: currentValue.nome,
          departamento: currentValue.departamento,
          mes_ref: currentValue.mes_ref,
          ano_ref: currentValue.ano_ref,
          dados: []
        }).dados.push(currentValue);
        return result;
      }, {});
    }
  },

  mounted() {
    if (this.filters != {}) {
      const date = new Date().toISOString().substr(0, 7);
      const [year, month] = date.split("-");
      const filter = {
        ano_ref: parseInt(year),
        mes_ref: parseInt(month)
      };
      this.fetchRealizadoIndividual(filter);
    }
  }
};
</script>
